import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes, Route } from 'react-router';
import './App.css';
import './i18n/config'; // Import i18n configuration
import Footer from './components/Footer/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Chatbot from './components/Chatbot';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Solutions from './pages/Solutions';
import BlogList from './components/Blog/BlogList';
import BlogPost from './components/Blog/BlogPost';
import SolutionPost from './components/Solutions/SolutionPost';
import Software from './pages/Software';
import Partners from './pages/Partners';
import Industries from './pages/Industries';
import Projects from './pages/Projects';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import FireSafetyPage from './pages/FireSafetyPage';
import ITSecurityPage from './pages/ITSecurityPage';
import HVACSolutionsPage from './pages/HVACSolutionsPage';
import MaintenancePage from './pages/MaintenancePage';

import CCTVSystemsPage from './pages/CCTVSystemsPage';
import AccessControlPage from './pages/AccessControlPage';
import AlarmSystemsPage from './pages/AlarmSystemsPage';
import NetworkSecurityPage from './pages/NetworkSecurityPage';
import SmartHomePage from './pages/SmartHomePage';
import SoftwareDesignPage from './pages/SoftwareDesignPage';
import SoftwareDigitalMarketingPage from './pages/SoftwareDigitalMarketingPage';
import SoftwareAfterSalesPage from './pages/SoftwareAfterSalesPage';
import SoftwareWebDevelopmentPage from './pages/SoftwareWebDevelopmentPage';
import SoftwareWebScrappingPage from './pages/SoftwareWebScrappingPage';
import SoftwareAndroidDevelopmentPage from './pages/SoftwareAndroidDevelopmentPage';
import SoftwareARVRPage from './pages/SoftwareARVRPage';
import DynamicServicePage from './pages/DynamicServicePage';
import Navbar from './components/Header/Navbar';
import RouteProgress from './components/common/RouteProgress';
import SmoothScroll from './components/common/SmoothScroll';
import GoogleAnalytics from './components/common/GoogleAnalytics';

function App(): JSX.Element {
  return (
    <Router>
      <div className="App">
        <SmoothScroll />
        <RouteProgress />
        <GoogleAnalytics />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solution" element={<Solutions />} />
            <Route path="/software" element={<Software />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/fire-safety" element={<FireSafetyPage />} />
            <Route path="/it-security" element={<ITSecurityPage />} />
            <Route path="/hvac-solutions" element={<HVACSolutionsPage />} />
            <Route path="/maintenance" element={<MaintenancePage />} />

            <Route path="/cctv-systems" element={<CCTVSystemsPage />} />
            <Route path="/access-control" element={<AccessControlPage />} />
            <Route path="/alarm-systems" element={<AlarmSystemsPage />} />
            <Route path="/network-security" element={<NetworkSecurityPage />} />
            <Route path="/smart-home" element={<SmartHomePage />} />
            <Route path="/software-design" element={<SoftwareDesignPage />} />
            <Route path="/software-digital-marketing" element={<SoftwareDigitalMarketingPage />} />
            <Route path="/software-after-sales" element={<SoftwareAfterSalesPage />} />
            <Route path="/software-web-development" element={<SoftwareWebDevelopmentPage />} />
            <Route path="/software-web-scrapping" element={<SoftwareWebScrappingPage />} />
            <Route path="/software-android-development" element={<SoftwareAndroidDevelopmentPage />} />
            <Route path="/software-ar-vr" element={<SoftwareARVRPage />} />
            {/* Sanity Studio */}
            {/* <Route path="/studio/*" element={<StudioPage />} /> */}
            <Route path="/blogs" element={<BlogList />} />
            <Route path="/blogs/:slug" element={<BlogPost />} />
            <Route path="/solutions/:slug" element={<SolutionPost />} />

            {/* Dynamic routes for API-fetched categories */}
            <Route path="/software/:subcategorySlug" element={<DynamicServicePage />} />
            <Route path="/product/:subcategorySlug" element={<DynamicServicePage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <Chatbot />
      </div>
    </Router>
  );
}

export default App;
